import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getImgList as _getImgList } from '@/api/queryTemplate';
export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      showImgVisible: false,
      imgList: []
    };
  },
  methods: {
    getImgList: function () {
      var _getImgList2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(colorId) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.showImgVisible = true;
              _context.next = 3;
              return _getImgList(colorId);
            case 3:
              result = _context.sent;
              if (result.code === 200) {
                this.imgList = result.data;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getImgList(_x) {
        return _getImgList2.apply(this, arguments);
      }
      return getImgList;
    }()
  }
};